import resultStyles from '@/styles/molecules/Result/styles.module.css'
import Result from '@/components/shared/Result'
import logger from '@/lib/logger'

const Intro = ({onClick, loggerAction}) => {
  const click = () => {
    onClick()
    logger.action(loggerAction)
  }
  return (
    <div className={resultStyles.ecResult__wrapper_padding}>
      <Result
        illustration="/img/illustrations/Ilustra.svg"
        title="Avaliar Imóvel"
        text="Comparamos o seu imóvel com anúncios de imóveis similares para recomendar um valor de venda competitivo"
        buttons={[
          {
            active: true,
            label: 'Quero Avaliar',
            onClick: click
          }
        ]}
      />
    </div>
  )
}
export default Intro
